"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.REVENUES_ES = exports.REVENUES_EN = exports.REVENUES = void 0;
exports.REVENUES = [
    {
        label: 'Micro Empresa (faturamento anual até R$350.000)',
        value: '0-350000',
    },
    {
        label: 'Pequena Empresa (faturamento anual de R$350.000 até R$5 Milhões)',
        value: '350000-5000000',
    },
    {
        label: 'Média Empresa (faturamento anual de R$5 Milhões até R$20 Milhões)',
        value: '5000000-20000000',
    },
    {
        label: 'Grande Empresa (faturamento anual de R$20 Milhões até R$100 Milhões)',
        value: '20000000-100000000',
    },
    {
        label: 'Grande Empresa II (faturamento anual acima de R$100 Milhões)',
        value: '100000000-',
    },
    {
        label: 'Não se aplica',
        value: null,
    },
];
exports.REVENUES_EN = [
    {
        label: 'Micro Enterprise (annual turnover up to R$350,000)',
        value: '0-350000',
    },
    {
        label: 'Small Business (annual turnover of R$350,000 to R$5 Million)',
        value: '350000-5000000',
    },
    {
        label: 'Medium Enterprise (annual turnover of R$5 Million to R$20 Million)',
        value: '5000000-20000000',
    },
    {
        label: 'Large Company (annual turnover of R$20 Million to R$100 Million)',
        value: '20000000-100000000',
    },
    {
        label: 'Large Company II (annual turnover above R$100 Million)',
        value: '100000000-',
    },
    {
        label: 'Not applicable',
        value: null,
    },
];
exports.REVENUES_ES = [
    {
        label: 'Microempresa (facturación anual hasta R$350.000)',
        value: '0-350000',
    },
    {
        label: 'Pequeña empresa (facturación anual de R$350.000 a R$5 millones)',
        value: '350000-5000000',
    },
    {
        label: 'Mediana empresa (ingresos anuales de R$5 millones hasta R$20 millones)',
        value: '5000000-20000000',
    },
    {
        label: 'Gran empresa (facturación anual de R$20 millones a R$100 millones)',
        value: '20000000-100000000',
    },
    {
        label: 'Gran Empresa II (facturación anual superior a R$100 millones)',
        value: '100000000-',
    },
    {
        label: 'No se aplica',
        value: null,
    },
];
//# sourceMappingURL=revenues.js.map